module.exports = __webpack_public_path__ + "static/media/tick.ddabe1f8.svg";